const attribute = "data-gull-message";
const variants = ["danger", "success", "warning"];

// Native Jodit controls retain the editor selection for mouse and keyboard actions.
export function applyMessagePreset(editor, variant) {
  if (variant !== "normal" && !variants.includes(variant)) return;
  const selection = editor.s;
  selection.focus();
  const range = selection.range;
  const node = selection.current();
  const element = node?.nodeType === 1 ? node : node?.parentElement;
  const current = element?.closest(`[${attribute}]`);
  const inCurrent = current && editor.editor.contains(current) && current.contains(range.endContainer) && current.contains(range.startContainer);

  if (variant === "normal") {
    // Remove only the preset, keeping text, links, lists and inline formatting.
    editor.editor.querySelectorAll(`[${attribute}]`).forEach(block => {
      if (selection.isCollapsed() ? block === current : range.intersectsNode(block)) block.removeAttribute(attribute);
    });
  } else if (inCurrent) {
    current.setAttribute(attribute, variant);
  } else if (selection.isCollapsed()) {
    const block = editor.editorDocument.createElement("div");
    block.setAttribute(attribute, variant);
    block.innerHTML = "<p><br></p>";
    selection.insertNode(block, false);
    // A normal paragraph after the block makes it possible to continue outside it.
    const after = editor.editorDocument.createElement("p");
    after.innerHTML = "<br>";
    block.after(after);
    selection.setCursorIn(block.firstChild, true);
  } else {
    const block = editor.editorDocument.createElement("div");
    block.setAttribute(attribute, variant);
    block.appendChild(range.extractContents());
    // Replace nested presets instead of stacking backgrounds on an existing alert.
    block.querySelectorAll(`[${attribute}]`).forEach(child => child.removeAttribute(attribute));
    selection.insertNode(block, false);
    selection.select(block, true);
  }
  editor.synchronizeValues();
}

export const messagePresetButtons = ["messageDanger", "messageSuccess", "messageWarning", "messageNormal"];
export const messagePresetControls = Object.fromEntries([
  ["Danger", "danger", "Danger · Errore o comunicazione critica"],
  ["Success", "success", "Success · Esito positivo o conferma"],
  ["Warning", "warning", "Warning · Avviso o attenzione"],
  ["Normal", "normal", "Rimuovi lo stile dal blocco"],
].map(([name, variant, tooltip]) => [`message${name}`, {
  text: variant === "normal" ? "Normale" : name,
  tooltip,
  template: () => `<span class="fw-bold text-${variant === "normal" ? "primary" : variant}">${variant === "normal" ? "Normale" : name}</span>`,
  exec: editor => applyMessagePreset(editor, variant),
}]));
